import { getLayout, getPaint, getStyleType } from './layerStyler'

export default function initialApnLayers(features) {
  var initialApnSource = {
    key: 'initial_APN_source',
    id: 'initial_APN_source',
    type: 'geojson',
    data: features,
  }

  var initialApnLayer = {
    id: 'initial_APN',
    type: getStyleType('MULTIPOLYGON'),
    source: 'initial_APN_source',
    layout: getLayout('MULTIPOLYGON', 'visible'),
    paint: getPaint('MULTIPOLYGON', '#cbff9d'),
  }

  var initialApnOutlineLayer = {
    id: 'initial_APN_outline',
    type: 'line',
    source: 'initial_APN_source',
    layout: getLayout('OUTLINE', 'visible'),
    paint: getPaint('OUTLINE', '#cbff9d'),
  }

  return { initialApnSource, initialApnLayer, initialApnOutlineLayer }
}
